import React from "react";
import { Resource } from "react-admin";
import {
  RentalsList,
  PendingRentalsList,
  RentalsDueList,
  PendingRentalShow
} from "./resources/rentals";
import { TourList } from "./resources/tour_list";

import {
  PendingTourBookingsList,
  PendingTourShow
} from "./resources/pending_tours";

import { ClientList, ClientEdit } from "./resources/clients";
import { CountryList, CountryEdit } from "./resources/countries";

import { PaymentShow, PaymentList } from "./resources/payments";
import { SaleVehicleEdit, SaleVehicleShow } from "./resources/saleBike";

import { TransferCreate, TransferEdit } from "./resources/transfers";
import {
  TransferItemCreate,
  TransferItemEdit
} from "./resources/transferItems";
import { TourEdit, TourCreate } from "./resources/tours";
import { TourPriceEdit, TourPriceList } from "./resources/tourPrices";
import { VehicleList, VehicleEdit, VehicleCreate } from "./resources/vehicles";
import { VehicleSwitch } from "./resources/vehicleSwitch";
import { VehicleObsolenceList } from "./resources/bike_obsolence";
import {
  VehicleDamageList,
  VehicleDamageEdit,
  VehicleDamageCreate
} from "./resources/vehicleDamages";
import {
  VehicleModelList,
  VehicleModelEdit,
  VehicleModelCreate
} from "./resources/vehicleModels";
import { RentalPriceEdit, RentalPriceCreate } from "./resources/rentalPrices";
import { GpsList, GpsEdit, GpsCreate } from "./resources/gpsDevices";
import {
  BlackListsList,
  BlackListsEdit,
  BlackListsCreate
} from "./resources/blackLists";

import { MaintenanceDueList } from "./resources/maintenancesDue";

import {
  MaintenanceItemTypeList,
  MaintenanceItemTypeEdit,
  MaintenanceItemTypeCreate
} from "./resources/maintenanceItemTypes";
import {
  MaintenanceItemList,
  MaintenanceItemEdit,
  MaintenanceItemCreate
} from "./resources/maintenanceItems";
import { MaintenanceEdit, MaintenanceCreate } from "./resources/maintenances";

import { GloveList, GloveEdit, GloveCreate } from "./resources/gloves";
import { HelmetEdit, HelmetList, HelmetCreate } from "./resources/helmets";
import { JacketEdit, JacketList, JacketCreate } from "./resources/jackets";
import { TankbagList, TankbagEdit, TankbagCreate } from "./resources/tankbags";
import { SeatList, SeatEdit, SeatCreate } from "./resources/seats";
import { BookingList, BookingEdit } from "./resources/bookings";
import { HoldList, HoldEdit, HoldCreate } from "./resources/holds";
import {
  HolidaysList,
  HolidaysEdit,
  HolidaysCreate
} from "./resources/holidays";
import {
  LocationsList,
  LocationsCreate,
  LocationsEdit
} from "./resources/locations";
import {
  TourZonesList,
  TourZonesCreate,
  TourZonesEdit
} from "./resources/tourZones";

import { UsersList, UsersCreate, UsersEdit } from "./resources/users";
import { GuidesList, GuidesCreate, GuidesEdit } from "./resources/guides";

import { TourDetailEdit, TourDetailCreate } from "./resources/tourDetails";
import { PricetEdit, PricetCreate } from "./resources/pricest";
import {
  TourVanPassengerEdit,
  TourVanPassengerCreate
} from "./resources/tourVanPassengers";
import { TourGuideCreate, TourGuideList } from "./resources/tourGuides";
import {
  TourGpsDeviceCreate,
  TourGpsDeviceList
} from "./resources/tourGpsDevices";
import { TourBikeCreate, TourBikeList } from "./resources/tourBikes";
import { TourVanCreate, TourVanList } from "./resources/tourVans";
import {
  TourNameCreate,
  TourNameList,
  TourNameEdit
} from "./resources/tourNames";
import {
  ExtraKmRentalsList,
  ExtraKmRentalsEdit
} from "./resources/extraKmRentals";
import { UnenteredKmTourBikesEdit, UnenteredKmToursBikesList } from "./resources/unenteredKmTourBikes";
import { UnenteredKmTourVansEdit, UnenteredKmToursVansList } from "./resources/unenteredKmTourVans";
import {
  UnenteredKmRentalsList,
  UnenteredKmRentalsEdit
} from "./resources/unenteredKmRentals";
import { ToursDueList } from "./resources/list_tours_due/toursDue";
import { ToursClientsDueList } from "./resources/tourClients";
import { TourClientsShow } from "./resources/tourClients";
import { RentalClientsShow } from "./resources/rentalClients";
import { MergeList } from "./resources/clientsMerge";
import { AgencyList, AgencyEdit, AgencyCreate } from "./resources/agencies";

const resources = [
  <Resource key="clients" name="clients" list={ClientList} edit={ClientEdit} />,
  <Resource key="agencies" name="agencies" list={AgencyList} edit={AgencyEdit} create={AgencyCreate}/>,
  <Resource key="clientsMerge" name="clientsMerge" list={MergeList} />,
  <Resource
    key="vehicle_models"
    name="vehicle_models"
    list={VehicleModelList}
    edit={VehicleModelEdit}
    create={VehicleModelCreate}
  />,
  <Resource
    key="rental_prices"
    name="rental_prices"
    edit={RentalPriceEdit}
    create={RentalPriceCreate}
  />,
  <Resource key="vehicle_statuses" name="vehicle_statuses" />,
  <Resource key="referrals" name="referrals" />,
  <Resource key="insurance_statuses" name="insurance_statuses" />,
  <Resource
    key="countries"
    name="countries"
    list={CountryList}
    edit={CountryEdit}
  />,
  <Resource
    key="vehicles"
    name="vehicles"
    list={VehicleList}
    edit={VehicleEdit}
    create={VehicleCreate}
  />,
  <Resource
    key="bike_obsolence"
    name="bike_obsolence"
    list={VehicleObsolenceList}
  />,
  <Resource
    key="bikes_available_to_switch"
    name="bikes_available_to_switch"
    edit={VehicleSwitch}
  />,
  <Resource
    key="vehicle_damages"
    name="vehicle_damages"
    list={VehicleDamageList}
    edit={VehicleDamageEdit}
    create={VehicleDamageCreate}
  />,
  <Resource
    key="gps_devices"
    name="gps_devices"
    list={GpsList}
    edit={GpsEdit}
    create={GpsCreate}
  />,
  <Resource
    key="maintenance_item_types"
    name="maintenance_item_types"
    list={MaintenanceItemTypeList}
    edit={MaintenanceItemTypeEdit}
    create={MaintenanceItemTypeCreate}
  />,
  <Resource
    key="maintenance_items"
    name="maintenance_items"
    list={MaintenanceItemList}
    edit={MaintenanceItemEdit}
    create={MaintenanceItemCreate}
  />,
  <Resource
    key="maintenances"
    name="maintenances"
    edit={MaintenanceEdit}
    create={MaintenanceCreate}
  />,
  <Resource
    key="black_lists"
    name="black_lists"
    list={BlackListsList}
    edit={BlackListsEdit}
    create={BlackListsCreate}
  />,
  <Resource
    key="maintenances_due"
    name="maintenances_due"
    list={MaintenanceDueList}
  />,
  <Resource
    key="gloves"
    name="gloves"
    list={GloveList}
    edit={GloveEdit}
    create={GloveCreate}
  />,
  <Resource
    key="seats"
    name="seats"
    list={SeatList}
    edit={SeatEdit}
    create={SeatCreate}
  />,
  <Resource
    key="tankbags"
    name="tankbags"
    list={TankbagList}
    edit={TankbagEdit}
    create={TankbagCreate}
  />,
  <Resource
    key="helmets"
    name="helmets"
    list={HelmetList}
    edit={HelmetEdit}
    create={HelmetCreate}
  />,
  <Resource
    key="jackets"
    name="jackets"
    list={JacketList}
    edit={JacketEdit}
    create={JacketCreate}
  />,
  <Resource
    key="holds"
    name="holds"
    list={HoldList}
    edit={HoldEdit}
    create={HoldCreate}
  />,
  <Resource key="rentals" name="rentals" list={RentalsList} />,
  <Resource key="tour_list" name="tour_list" list={TourList} />,
  <Resource
    key="transfers"
    name="transfers"
    create={TransferCreate}
    edit={TransferEdit}
  />,
  <Resource
    key="transfer_items"
    name="transfer_items"
    create={TransferItemCreate}
    edit={TransferItemEdit}
  />,
  <Resource key="agents" name="agents" />,
  <Resource key="tours" name="tours" edit={TourEdit} create={TourCreate} />,
  <Resource
    key="tour_prices"
    name="tour_prices"
    edit={TourPriceEdit}
    list={TourPriceList}
  />,
  <Resource key="tour_clients" name="tour_clients" show={TourClientsShow} />,
  <Resource key="tour_due_list" name="tour_due_list" list={ToursDueList} />,
  <Resource
    key="rental_clients"
    name="rental_clients"
    show={RentalClientsShow}
  />,
  <Resource key="prices" name="prices" />,
  <Resource
    key="pricest"
    name="pricest"
    edit={PricetEdit}
    create={PricetCreate}
  />,
  <Resource key="cities" name="cities" />,
  <Resource
    key="payments"
    name="payments"
    show={PaymentShow}
    list={PaymentList}
  />,
  <Resource
    key="sale_bike"
    name="sale_bike"
    edit={SaleVehicleEdit}
    show={SaleVehicleShow}
  />,

  <Resource key="charges" name="charges" />,
  <Resource key="vehicle_categories" name="vehicle_categories" />,
  <Resource key="vehicle_types" name="vehicle_types" />,
  <Resource key="rewards" name="rewards" />,
  <Resource key="item_locations" name="item_locations" />,
  <Resource key="tours_passenger" name="tours_passenger" />,

  <Resource key="tour_types" name="tour_types" />,
  <Resource
    key="tour_details"
    name="tour_details"
    edit={TourDetailEdit}
    create={TourDetailCreate}
  />,
  <Resource
    key="tour_names"
    name="tour_names"
    edit={TourNameEdit}
    create={TourNameCreate}
    list={TourNameList}
  />,
  <Resource key="restaurants" name="restaurants" />,
  <Resource key="hotels" name="hotels" />,
  <Resource
    key="extra_km_rentals"
    name="extra_km_rentals"
    list={ExtraKmRentalsList}
    edit={ExtraKmRentalsEdit}
  />,
  <Resource
    key="unentered_km_rentals"
    name="unentered_km_rentals"
    list={UnenteredKmRentalsList}
    edit={UnenteredKmRentalsEdit}
  />,
  <Resource
    key="unentered_km_tour_bikes"
    name="unentered_km_tour_bikes"
    list={UnenteredKmToursBikesList}
    edit={UnenteredKmTourBikesEdit}
  />,
  <Resource
    key="unentered_km_tour_vans"
    name="unentered_km_tour_vans"
    list={UnenteredKmToursVansList}
    edit={UnenteredKmTourVansEdit}
  />,
  <Resource
    key="van_passengers"
    name="van_passengers"
    edit={TourVanPassengerEdit}
    create={TourVanPassengerCreate}
  />,
  <Resource key="tour_passengers" name="tour_passengers" />,
  <Resource
    key="bookings"
    name="bookings"
    list={BookingList}
    edit={BookingEdit}
  />,
  <Resource
    key="pending_rentals"
    name="pending_rentals"
    show={PendingRentalShow}
    list={PendingRentalsList}
  />,
  <Resource key="rentals_due" name="rentals_due" list={RentalsDueList} />,
  <Resource
    key="holidays"
    name="holidays"
    list={HolidaysList}
    create={HolidaysCreate}
    edit={HolidaysEdit}
  />,
  <Resource
    key="locations"
    name="locations"
    list={LocationsList}
    create={LocationsCreate}
    edit={LocationsEdit}
  />,
  <Resource key="location_recommended_bikes" name="location_recommended_bikes" />,
  <Resource
    key="tour_zones"
    name="tour_zones"
    list={TourZonesList}
    create={TourZonesCreate}
    edit={TourZonesEdit}
  />,
  <Resource
    key="users"
    name="users"
    list={UsersList}
    create={UsersCreate}
    edit={UsersEdit}
  />,
  <Resource
    key="guides"
    name="guides"
    list={GuidesList}
    create={GuidesCreate}
    edit={GuidesEdit}
  />,
  <Resource
    key="tour_guides"
    name="tour_guides"
    create={TourGuideCreate}
    list={TourGuideList}
  />,
  <Resource
    key="tour_bikes"
    name="tour_bikes"
    create={TourBikeCreate}
    list={TourBikeList}
  />,
  <Resource
    key="tour_vans"
    name="tour_vans"
    create={TourVanCreate}
    list={TourVanList}
  />,
  <Resource
    key="tour_gps_devices"
    name="tour_gps_devices"
    create={TourGpsDeviceCreate}
    list={TourGpsDeviceList}
  />,
  <Resource
    key="tour_special_motorcycles"
    name="tour_special_motorcycles"
  />
];

export default resources;



// WEBPACK FOOTER //
// ./src/resources.js